function makeSchema() {
    return {
        '@context': 'http://schema.org',
        '@type': 'Corporation',
        name: 'Viome Life Sciences, Inc.',
        url: 'https://www.viomelifesciences.com/',
        logo: 'https://images.ctfassets.net/qk4l4jfatr3e/5TopVWBait8wmN0DMQQe11/b4823142f10653b02cff037fc0e0e635/viome-dark-logo.svg',
        contactPoint: {
            '@type': 'ContactPoint',
            telephone: '+1-855-958-4663',
            contactType: 'customer service',
            contactOption: 'TollFree',
        },
        sameAs: [
            'https://www.facebook.com/MyViome',
            'https://twitter.com/myviome',
            'https://www.youtube.com/viome',
            'https://www.linkedin.com/company/viome/',
            'https://www.instagram.com/viome/',
        ],
    };
}

export default function Schema() {
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(makeSchema()),
            }}
        />
    );
}
